import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Typography, Button, CircularProgress } from "@material-ui/core";

const HOT_PINK = "#fe0d9d";

class VenueEditSuperPayStep extends Component {
    state = { loading: true, availableOrgs: null };

    componentDidMount() {
        const { venueHgSuperPayStore, organisationStore } = this.props;
        if (venueHgSuperPayStore.organisationId) {
            this.setState({ loading: false });
            return;
        }
        organisationStore.loadOrganisations().then(orgs => {
            if (!orgs || orgs.length === 0) {
                this.setState({ loading: false });
                return;
            }
            if (orgs.length === 1) {
                venueHgSuperPayStore.loadForOrganisation(orgs[0].id).then(() => {
                    this.setState({ loading: false });
                }).catch(() => {
                    this.setState({ loading: false });
                });
            } else {
                // Multiple orgs: let user pick the correct org context.
                this.setState({ loading: false, availableOrgs: orgs });
            }
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    _selectOrg = (orgId) => {
        const { venueHgSuperPayStore } = this.props;
        this.setState({ loading: true, availableOrgs: null });
        venueHgSuperPayStore.loadForOrganisation(orgId).then(() => {
            this.setState({ loading: false });
        }).catch(() => {
            this.setState({ loading: false });
        });
    };

    render() {
        const { loading, availableOrgs } = this.state;
        const { venueHgSuperPayStore, profileId, history } = this.props;
        const { employerModel } = venueHgSuperPayStore;

        if (loading) {
            return (
                <div style={{ padding: 32, textAlign: "center" }}>
                    <CircularProgress style={{ color: HOT_PINK }} />
                </div>
            );
        }

        if (availableOrgs) {
            return (
                <div style={{ padding: "24px 0" }}>
                    <Typography variant="subheading" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                        Select Organisation
                    </Typography>
                    <Typography variant="body1" style={{ color: "#6b7280", marginBottom: 16 }}>
                        This venue belongs to multiple organisations. Select which one to manage HG Super Pay for:
                    </Typography>
                    {availableOrgs.map(org => (
                        <Button
                            key={org.id}
                            variant="outlined"
                            style={{ marginRight: 8, marginBottom: 8, borderColor: HOT_PINK, color: HOT_PINK }}
                            onClick={() => this._selectOrg(org.id)}
                        >
                            {org.name || `Organisation ${org.id}`}
                        </Button>
                    ))}
                </div>
            );
        }

        if (!employerModel) {
            return (
                <div style={{ padding: "24px 0" }}>
                    <Typography variant="subheading" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                        HG Super Pay
                    </Typography>
                    <Typography variant="body1" style={{ color: "#6b7280", marginBottom: 16 }}>
                        HG Super Pay is not yet configured for your organisation. Set up your employer model to start managing super payments.
                    </Typography>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: HOT_PINK, color: "#fff", fontWeight: 700 }}
                        onClick={() => history.push("/organisation/hg-super-pay")}
                    >
                        Set Up Now
                    </Button>
                </div>
            );
        }

        if (employerModel === "group") {
            return (
                <div style={{ padding: "24px 0" }}>
                    <Typography variant="subheading" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                        HG Super Pay — Group Employer Mode
                    </Typography>
                    <Typography variant="body1" style={{ color: "#6b7280", marginBottom: 8 }}>
                        Your organisation uses a <strong>shared Group Employer account</strong>. All venues in the group contribute super through one centralised employer record and subscription.
                    </Typography>
                    <Typography variant="body2" style={{ color: "#6b7280", marginBottom: 20 }}>
                        Super for artists booked at this venue is managed from the Organisation hub — no separate setup is needed here.
                    </Typography>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: HOT_PINK, color: "#fff", fontWeight: 700 }}
                        onClick={() => history.push("/organisation/hg-super-pay")}
                    >
                        Open Group Hub
                    </Button>
                </div>
            );
        }

        return (
            <div style={{ padding: "24px 0" }}>
                <Typography variant="subheading" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                    HG Super Pay — Per-Venue Mode
                </Typography>
                <Typography variant="body1" style={{ color: "#6b7280", marginBottom: 8 }}>
                    Your organisation uses <strong>Per-Venue Employer mode</strong>. Each venue manages its own employer account and subscription independently.
                </Typography>
                <Typography variant="body2" style={{ color: "#6b7280", marginBottom: 20 }}>
                    Manage employer setup, employee mapping, and contribution history for this specific venue below.
                </Typography>
                <Button
                    variant="contained"
                    style={{ backgroundColor: HOT_PINK, color: "#fff", fontWeight: 700 }}
                    onClick={() => {
                        const orgId = venueHgSuperPayStore.organisationId;
                        venueHgSuperPayStore.setSelectedVenue(profileId);
                        history.push(orgId
                            ? `/organisation/${orgId}/hg-super-pay`
                            : "/organisation/hg-super-pay"
                        );
                    }}
                >
                    Manage This Venue's HG Super Pay
                </Button>
                <Button
                    variant="outlined"
                    style={{ marginLeft: 12, color: HOT_PINK, borderColor: HOT_PINK }}
                    onClick={() => {
                        const orgId = venueHgSuperPayStore.organisationId;
                        history.push(orgId
                            ? `/organisation/${orgId}/hg-super-pay`
                            : "/organisation/hg-super-pay"
                        );
                    }}
                >
                    View Org Overview
                </Button>
            </div>
        );
    }
}

export default inject("venueHgSuperPayStore", "organisationStore")(observer(VenueEditSuperPayStep));
